<template>
  <div class="careforsociety">
    <div
      class="mobile-show"
      style="
      width: 100vw;
      height: calc(100vw * 0.125);
      position:absolute;
      top:0;
      background: url(./img/mobile_header_bg1.jpg) center top  / cover;
      background-repeat: no-repeat;
     "
    ></div>
    <div
      class="container mobile-hide"
      style="
      height: 150px;
      background: url(./img/careforsociety_bottom.png)center center /cover;"
    ></div>
    <div class="container" style="text-align:left;margin-bottom:16px;">
      <div class="columns">
        <div class="column" style="padding-bottom:0; font-size:48px;">
          <span class="title-size">{{$t('body.video_title')}}</span>
        </div>
      </div>
    </div>

    <div class="container mobile-hide">
      <div class="columns">
        <div
          @mouseenter="hilightTableIn"
          @mouseleave="hilightTableOut"
          @click="clickThumb('vid3')"
          class="column hilight-table"
          style="
          background-image:url('./img/vidthumb3.png');
          background-position: center;
          background-size: cover;
          height:300px;
          border: solid white 4px;
          display: flex;
          justify-content: center;
          align-items: center;"
        >
          <div>
            <img src="img/button_play.png" alt="play" height="62" width="62" />
          </div>
        </div>
        
        <div
          @mouseenter="hilightTableIn"
          @mouseleave="hilightTableOut"
          @click="clickThumb('vid2')"
          class="column hilight-table"
          style="
          background-image:url('./img/vidthumb2.png');
          background-position: center;
          background-size: cover;
          height:300px;
          border: solid white 4px;
          display: flex;
          justify-content: center;
          align-items: center;"
        >
          <div>
            <img src="img/button_play.png" alt="play" height="62" width="62" />
          </div>
        </div>
<!-- <div -->
<!--           @mouseenter="hilightTableIn" -->
<!--           @mouseleave="hilightTableOut" -->
<!--           @click="clickThumb('vid1')" -->
<!--           class="column hilight&#45;table" -->
<!--           style=" -->
<!--           background&#45;image:url('./img/vidthumb1.png'); -->
<!--           background&#45;position: center; -->
<!--           background&#45;size: cover; -->
<!--           height:300px; -->
<!--           border: solid white 4px; -->
<!--           display: flex; -->
<!--           justify&#45;content: center; -->
<!--           align&#45;items: center;" -->
<!--         > -->
<!--           <div> -->
<!--             <img src="img/button_play.png" alt="play" height="62" width="62" /> -->
<!--           </div> -->
<!--         </div> -->
      </div>
      <div class="container middle-separator line-bottom-right">
        <img style="position: relative; top: 6px;" src="img/chinese_result.jpg" alt width="60" />
      </div>
    </div>
    <div class="mobile-hide">
      <div v-if="selected_video == 'vid3'" class="container video-container">
        <iframe
          src="https://www.youtube.com/embed/UJ9lf_9bDe0"
          frameborder="0"
          allow="autoplay; encrypted-media;"
          allowfullscreen
          class="video"
        ></iframe>
      </div>
      <div v-if="selected_video == 'vid1'" class="container video-container">
        <iframe
          src="https://www.youtube.com/embed/OzzWrTcDmMc"
          frameborder="0"
          allow="autoplay; encrypted-media;"
          allowfullscreen
          class="video"
        ></iframe>
      </div>
      <div v-if="selected_video == 'vid2'" class="container video-container">
        <iframe
          src="https://www.youtube.com/embed/s9YU9w0CcMg"
          frameborder="0"
          allow="autoplay; encrypted-media;"
          allowfullscreen
          class="video"
        ></iframe>
      </div>
    </div>
    <div class="mobile-show">
      <div class="container mobile-video-container">
        <iframe
          src="https://www.youtube.com/embed/UJ9lf_9bDe0"
          frameborder="0"
          allow="autoplay; encrypted-media;"
          allowfullscreen
          class="video"
        ></iframe>
      </div>
      <div class="container mobile-video-container">
        <iframe
          src="https://www.youtube.com/embed/s9YU9w0CcMg"
          frameborder="0"
          allow="autoplay; encrypted-media;"
          allowfullscreen
          class="video"
        ></iframe>
      </div>
      <!-- <div class="container mobile&#45;video&#45;container"> -->
      <!--   <iframe -->
      <!--     src="https://www.youtube.com/embed/s9YU9w0CcMg" -->
      <!--     frameborder="0" -->
      <!--     allow="autoplay; encrypted&#45;media;" -->
      <!--     allowfullscreen -->
      <!--     class="video" -->
      <!--   ></iframe> -->
      <!-- </div> -->
 </div>
    <div style="position:relative;top:50px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>
<script>
export default {
  name: "brand",
  data() {
    return {
      selected_video: "vid3"
    };
  },
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
  },
  methods: {
    hilightTableIn(e) {
      let el = e.target;
      el.classList.toggle("over");
    },
    hilightTableOut(e) {
      let el = e.target;
      el.classList.toggle("over");
    },
    clickThumb(s) {
      let self = this;
      self.selected_video = s;
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-video-container {
  // background: #aaa;
  // padding-top: 40%;
  height: 180px;
  margin-bottom: 16px;
}
.video-container {
  background: #aaa;
  padding-top: 40%;
}
.video-container iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hilight-table {
  cursor: pointer;
  background-color: #00354c00;
  background-blend-mode: multiply;
  color: grey;
  font-size: 24px;
  div {
    opacity: 0;
    transition: all 300ms ease-in-out;
  }
  transition: all 300ms ease-in-out;
}
.hilight-table.over {
  cursor: pointer;
  background-color: #00354cc4;
  background-blend-mode: multiply;
  div {
    opacity: 1;
    transition: all 300ms ease-in-out;
  }
  transition: all 300ms ease-in-out;
}
</style>
